<template>
  <!-- 收益明细 -->
  <div class="day-detail-wrap">
    <p class="last-date">数据更新至 {{ updateDate }}</p>
    <div class="filtrate-wrap">
      <div class="radio-label">
        <span
          @click="changeLabel(index)"
          :class="['btn-label', activeLabel == index ? 'isActive' : 'default']"
          v-for="(label, index) in labelArr"
          :key="index"
          >{{ label }}</span
        >
      </div>
      <div class="query-form">
        <el-form
          ref="dayBillForm"
          :inline="true"
          :rules="rules"
          :model="formInline"
          class="form-inline"
        >
          <template v-if="activeLabel">
            <el-form-item label="货币类型">
              <el-select
                style="width: 90px; margin-right: 70px"
                class="select-input"
                v-model="formInline.moneyType"
                placeholder="货币类型"
                @change="changeMtype"
              >
                <el-option
                  size="medium"
                  :label="type.name"
                  :value="type.id"
                  v-for="type in moneyTypeArr"
                  :key="type.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="收益来源">
              <el-select
                style="width: 90px"
                v-model="formInline.incomeType"
                placeholder="收益来源"
              >
                <el-option
                  size="medium"
                  :label="source.name"
                  :value="source.id"
                  v-for="source in incomeTypeArr"
                  :key="source.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </template>
          <el-form-item label="选择日期" prop="date" style="margin-right: 0">
            <el-date-picker
              v-model="formInline.date"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              @change="changeDate"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <div class="btn-query" @click="queryTableFn">查找</div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="download-wrap" @click="exportFn">
      <img src="@/assets/images/icon_export.png" />
      <span>导出数据</span>
    </div>
    <Table
      v-loading="loading"
      v-if="activeLabel"
      :tableData="tableData"
      :tableField="activeLabel ? tableFieldBill : tableFieldDay"
      :key="activeLabel ? 'billDetail' : 'dayDetail'"
      :tableInfo="activeLabel ? billTableInfo : dayTableInfo"
      @changePage="changePageFn"
    ></Table>
    <!--每日账单表格-->
    <div class="data-table" v-else>
      <el-table :data="DayData" stripe>
        <el-table-column label="日期" prop="date" align="center">
        </el-table-column>
        <el-table-column label="迷你豆数量" prop="minibean" align="center">
        </el-table-column>
        <el-table-column label="迷你点数量" prop="minipoint" align="center">
        </el-table-column>
        <el-table-column label="贡献点数量" prop="contribution" align="center">
        </el-table-column>
        <el-table-column label="广告收入" align="center">
          <el-table-column label="触发器收入" prop="ad_trigger" align="center">
            <template slot="header">
              <el-tooltip placement="top">
                <span
                  >触发器收入
                  <img class="icon-help" src="@/assets/images/icon_help.png" />
                </span>

                <p slot="content" style="font-size: 16px; color: #fff">
                  在地图作品中，用户通过触发器观看的广告记为内购商店广告，该收入是广告收入的一部分。
                </p>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="内购商店收入" prop="ad_shop" align="center">
            <template slot="header">
              <el-tooltip placement="top">
                <span
                  >内购商店收入
                  <img class="icon-help" src="@/assets/images/icon_help.png" />
                </span>

                <p slot="content" style="font-size: 16px; color: #fff">
                  在地图作品中，用户通过观看开发者商店内商品的广告记为内购商店广告，该收入是广告收入的一部分。
                </p>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="通行证收入"
            prop="ad_passcheck"
            align="center"
          >
            <template slot="header">
              <el-tooltip placement="top">
                <span
                  >通行证收入
                  <img class="icon-help" src="@/assets/images/icon_help.png" />
                </span>

                <p slot="content" style="font-size: 16px; color: #fff">
                  在地图作品中，用户通过观看畅玩通行证的广告记为通行证广告，该收入是广告收入的一部分。
                </p>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="其他广告收入" prop="ad_other" align="center">
          </el-table-column>
          <el-table-column label="合计" prop="ad_sum" align="center">
          </el-table-column>
        </el-table-column>
        <!-- <el-table-column label="会员收入" prop="date" align="center">
        </el-table-column> -->
        <el-table-column label="激励金收入" align="center">
          <el-table-column
            label="星启激励A收入"
            prop="other_xingqi4_time"
            align="center"
          >
            <template slot="header">
              <el-tooltip placement="top">
                <span
                  >星启激励A收入
                  <img class="icon-help" src="@/assets/images/icon_help.png" />
                </span>

                <p slot="content" style="font-size: 16px; color: #fff">
                  2024年7-12月为星启6.0时长激励，2024年1-6月为星启5.0内购时长激励，2023年为星启4.0时长激励
                </p>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="星启计划4.0内购奖金"
            prop="other_xingqi4_shop"
            align="center"
          >
            <template slot="header">
              <el-tooltip placement="top">
                <span
                  >星启激励B收入
                  <img class="icon-help" src="@/assets/images/icon_help.png" />
                </span>

                <p slot="content" style="font-size: 16px; color: #fff">
                  2024年7-12月为星启6.0内购激励，2024年1-6月为星启5.0广告激励，2023年为星启4.0内购激励
                </p>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="新星计划收入"
            prop="other_newstar"
            align="center"
          >
            <template slot="header">
              <el-tooltip placement="top">
                <span
                  >新星计划收入
                  <img class="icon-help" src="@/assets/images/icon_help.png" />
                </span>

                <p slot="content" style="font-size: 16px; color: #fff">
                  官方不定期面向所有创作者的扶持活动，活动期间只要投稿作品就可瓜分奖励金。
                </p>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="星启计划2.0收入"
            prop="other_xingqi2"
            align="center"
          >
            <template slot="header">
              <el-tooltip placement="top">
                <span
                  >星启计划2.0收入
                  <img class="icon-help" src="@/assets/images/icon_help.png" />
                </span>

                <p slot="content" style="font-size: 16px; color: #fff">
                  创作者的作品可获得额外30%内购分成与0~30%的额外广告分成。
                </p>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="星启计划3.0收入"
            prop="other_xingqi3"
            align="center"
          >
            <template slot="header">
              <el-tooltip placement="top">
                <span
                  >星启计划3.0收入
                  <img class="icon-help" src="@/assets/images/icon_help.png" />
                </span>

                <p slot="content" style="font-size: 16px; color: #fff">
                  创作者的作品在满足条件后根据游戏时长、地图质量评定等条件可获得对应的游戏时长激励奖金。
                </p>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="赛事奖金收入"
            prop="other_match"
            align="center"
          >
          </el-table-column>
          <el-table-column label="其他收入" prop="other_dingzhi" align="center">
          </el-table-column>
          <el-table-column label="合计" prop="star_sum" align="center">
          </el-table-column>
        </el-table-column>
        <!-- <el-table-column label="其他收入" prop="date" align="center">
        </el-table-column> -->
        <el-table-column label="备注" prop="" align="center"> </el-table-column>
        <template slot="empty">
          <div class="img-no" v-if="showDefaultImg">
            <img
              class="img-no-data"
              src="@/assets/images/img_table_no_data.png"
            />
            <div class="noCart">暂无数据</div>
          </div>
        </template>
      </el-table>
    </div>
    <!-- <el-pagination
      background
      v-if="activeLabel"
      @current-change="handleCurrentChange"
      :current-page="billTableInfo.page"
      :page-size="billTableInfo.pageSize"
      layout="prev, pager, next,jumper"
      :total="billTableInfo.total"
      hide-on-single-page
    >
    </el-pagination> -->
    <el-pagination
      background
      v-if="!activeLabel"
      @current-change="handleCurrentChange"
      :current-page="dayTableInfo.page"
      :page-size="dayTableInfo.pageSize"
      layout="prev, pager, next,jumper"
      :total="dayTableInfo.total"
      hide-on-single-page
    >
    </el-pagination>
  </div>
</template>

<script>
import { errorTip } from '@/utils/index';
import Table from '../newTable';
import {
  getIncomeDayList,
  getIncomeBillList,
  exportDayData,
  exportBillData,
} from '@/api/income';
export default {
  name: 'detailBill',
  components: {
    Table,
  },
  data() {
    return {
      loading: false,
      vid: 1,
      showDefaultImg: false,
      formInline: {
        moneyType: 999,
        incomeType: 999,
        date: [
          new Date() - 3600 * 1000 * 24 * 7,
          new Date() - 3600 * 1000 * 24,
        ],
      },
      DayData: [],
      tableInfo: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      rules: {
        date: [{ required: true, message: '请选择日期', trigger: 'blur' }],
      },
      updateDate: '',
      pickerMinDate: '', //第一次选中的时间
      pickerOptions: {
        //选择时间回调
        onPick: obj => {
          this.pickerMinDate = new Date(obj.minDate).getTime();
        },
        disabledDate: time => {
          //let date new Date(time)
          if (this.pickerMinDate) {
            const day1 = 90 * 24 * 3600 * 1000;
            let maxTime = this.pickerMinDate + day1;
            let minTime = this.pickerMinDate - day1;
            return (
              time.getTime() > maxTime ||
              time.getTime() < minTime ||
              time.getTime() > Date.now()
            );
          }
          // console.log(time);
          // return time.getTime() + 1 * 24 * 3600 * 1000 > Date.now();
        },
      },
      moneyTypeArr: [
        { id: 999, name: '全部' },
        { id: 4, name: '迷你点' },
        { id: 2, name: '迷你豆' },
        { id: 3, name: '广告' },
        { id: 1, name: '贡献点' },
        { id: 5, name: '激励金' },
      ],
      incomeTypeArr: [
        { id: 999, name: '全部' },
        { id: 1, name: '地图' },
        { id: 2, name: '资源' },
        { id: 3, name: '激励金' },
      ],
      dayTableInfo: {
        page: 1,
        pageSize: 20,
        total: 0,
      },
      billTableInfo: {
        page: 1,
        pageSize: 20,
        total: 0,
      },
      labelArr: ['每日账单', '账单详情'],
      activeLabel: 0,

      tableFieldDay: [
        { label: '日期', prop: 'date' },
        {
          label: '迷你豆数量',
          prop: 'minibean',
          explain: '玩家使用迷你豆购买了作品或资源',
        },
        {
          label: '迷你点数量',
          prop: 'minipoint',
          explain: '玩家使用迷你点购买了作品或资源',
        },
        {
          label: '广告收入',
          prop: 'ad_income',
          explain:
            '玩家在作品或资源中观看了广告（广告收入需要2日后进账，请以实际进账金额为准）',
        },
        {
          label: '广告展示次数',
          prop: 'ad_count',
          explain: '在所有作品和资源中广告被观看的次数',
        },
        {
          label: '贡献点数量',
          prop: 'contribution',
          explain: '平台为作品支付的服务费',
        },
        {
          label: '其他收入',
          prop: 'other',
          explain: '参加活动、赛事获得奖金收益或激励收益',
        },
      ],
      tableFieldBill: [
        { label: '日期', prop: 'date' },
        {
          label: '货币类型',
          prop: 'money_type',
        },
        {
          label: '收益来源',
          prop: 'income_type',
        },
        {
          label: '数额',
          prop: 'num',
        },
      ],
      tableData: [],
    };
  },
  watch: {
    activeLabel(val) {
      this.formInline = {
        moneyType: 999,
        incomeType: 999,
        date: [new Date() - 3600 * 1000 * 24 * 6, new Date()],
      };
      if (val) {
        this.billTableInfo.page = 1;
        this.fetchIncomeBillList();
      } else {
        this.dayTableInfo.page = 1;
        this.fetchIncomeDayList();
      }
    },
    DayData(val) {
      val.length ? (this.showDefaultImg = false) : (this.showDefaultImg = true);
    },
  },
  mounted() {
    this.activeLabel ? this.fetchIncomeBillList() : this.fetchIncomeDayList();
    //埋点
    this.activeLabel ? this.billDetailShow() : this.dailyBillShow();
  },
  computed: {
    getDate() {
      let timeArr = [];
      if (typeof this.formInline.date[0] == 'number') {
        timeArr = [
          new Date(
            new Date(new Date() - 3600 * 1000 * 24 * 7).toDateString(),
          ).getTime() / 1000, // 0点时间戳

          new Date(new Date(new Date()).toDateString()).getTime() / 1000 +
            24 * 60 * 60 -
            1 -
            86400,
        ]; //23:59:59点时间戳;
      } else {
        console.log(
          'new Date(new Date(this.formInline.date[0]).toDateString()).getTime() / 1000',
          new Date(new Date(this.formInline.date[0]).toDateString()).getTime() /
            1000,
        );
        timeArr = [
          new Date(new Date(this.formInline.date[0]).toDateString()).getTime() /
            1000,
          new Date(new Date(this.formInline.date[1]).toDateString()).getTime() /
            1000 +
            24 * 60 * 60 -
            1,
        ];
      }
      return timeArr;
    },
  },
  methods: {
    changeLabel(index) {
      this.activeLabel = index;
      sessionStorage.setItem('activeLabel', index);
      this.activeLabel ? this.billDetailShow() : this.dailyBillShow();
    },
    handleCurrentChange(currPage) {
      this.dayTableInfo.page = currPage;
      this.fetchIncomeDayList();
    },
    billDetailShow() {
      //账单详情曝光埋点
      this.$log('billing_details_show', 85423, { v7: 1 });
    },
    dailyBillShow() {
      //每日账单曝光埋点
      this.$log('daily_billing_show', 85427, { v7: 1 });
    },
    //账单详情查询埋点
    changeMtype(value) {
      switch (value) {
        case 999:
          this.vid = 1;
          break;
        case 4:
          this.vid = 2;
          break;
        case 2:
          this.vid = 3;
          break;
        case 3:
          this.vid = 4;
          break;
        case 1:
          this.vid = 5;
          break;
        case 5:
          this.vid = 6;
          break;
        default:
          break;
      }
    },
    // 查询每日列表
    async fetchIncomeDayList() {
      try {
        this.loading = true;
        let data = {
          start_time: this.getDate[0],
          end_time: this.getDate[1],
          page: this.dayTableInfo.page,
          page_size: this.dayTableInfo.pageSize,
        };
        const res = await getIncomeDayList(data);
        let num = 0;
        if (res.data.list.length) {
          this.DayData = res.data.list.map(item => {
            //判断数据是否全部为0
            if (
              item.ad_count === 0 &&
              item.ad_other === 0 &&
              item.ad_passcheck === 0 &&
              item.ad_shop === 0 &&
              item.ad_trigger === 0 &&
              item.minibean === 0 &&
              item.minipoint === 0 &&
              item.other_xingqi2 === 0 &&
              item.other_xingqi3 === 0 &&
              item.other_xingqi4_shop === 0 &&
              item.other_xingqi4_time === 0 &&
              item.other_newstar === 0 &&
              item.other_match === 0 &&
              item.other_dingzhi === 0
            ) {
              num = num + 1;
            }
            item.ad_sum =
              (
                item.ad_passcheck +
                item.ad_trigger +
                item.ad_shop +
                item.ad_other
              ).toFixed(2) || 0;
            item.star_sum =
              (
                item.other_xingqi2 +
                item.other_xingqi3 +
                item.other_newstar +
                item.other_match +
                item.other_dingzhi +
                item.other_xingqi4_shop +
                item.other_xingqi4_time
              ).toFixed(2) || 0;
            return item;
          });
        }
        if (num === res.data.total_count) this.DayData = [];
        console.log('---------- ', num, res.data);
        this.dayTableInfo.total = res.data.total_count;
        this.updateDate = res.data.update_date;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    async fetchIncomeBillList() {
      try {
        this.loading = true;
        let data = {
          start_time: this.getDate[0],
          end_time: this.getDate[1],
          page: this.billTableInfo.page,
          page_size: this.billTableInfo.pageSize,
          money_type: this.formInline.moneyType,
          income_type: this.formInline.incomeType,
        };
        const res = await getIncomeBillList(data);
        this.tableData = res.data.list;
        this.billTableInfo.total = res.data.total_count;
        this.updateDate = res.data.update_date;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    // 下载接口
    async fetchExport() {
      let data = {
        start_time: this.getDate[0],
        end_time: this.getDate[1],
      };
      try {
        let res = {};
        this.activeLabel
          ? (res = await exportBillData(data))
          : (res = await exportDayData(data));
        this.downloadFile(res.data.url);
        this.$message.success('下载成功');
      } catch (error) {
        console.log(error);
      }
    },

    changeDate(val) {
      if (val != null) {
        if ((val[1] - val[0] + 1) / 1000 / 60 / 60 / 24 > 365) {
          errorTip('最多选择90天，请重新选择查询时间');
        }
      }
    },
    queryTableFn() {
      this.$refs.dayBillForm.validateField('date', errMsg => {
        if (!errMsg) {
          let days = Math.round(
            (this.getDate[1] - this.getDate[0]) / 60 / 60 / 24,
          );

          if (days <= 365) {
            if (this.activeLabel) {
              this.billTableInfo.page = 1;
              this.fetchIncomeBillList();
            } else {
              this.dayTableInfo.page = 1;
              this.fetchIncomeDayList();
            }
          } else {
            errorTip('最多选择一年，请重新选择查询时间');
          }
        }
      });
      //账单详情查询埋点
      if (this.activeLabel) {
        this.$log('billing_details_click', 85424, { v7: 1, v8: this.vid });
      } else {
        //每日账单查询埋点
        this.$log('daily_billing_check_click', 85428, { v7: 1 });
      }
    },
    changePageFn(val) {
      if (this.activeLabel) {
        this.billTableInfo.page = val;
        this.fetchIncomeBillList();
      } else {
        this.dayTableInfo.page = val;
        this.fetchIncomeDayList();
      }
    },
    exportFn() {
      this.fetchExport();
      //收益详情导出埋点
      if (this.activeLabel) {
        this.$log('export_data_click', 85425, { v7: 1, v8: this.vid });
      } else {
        //每日账单导出数据点击
        this.$log('daily_dataexport_click', 85429, { v7: 1 });
      }
    },
    downloadFile(url) {
      let a = document.createElement('a');
      a.href = url;
      a.download = url.split('/').pop();
      a.click();
    },
  },
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;

.day-detail-wrap {
  .last-date {
    float: right;
    color: #8c8c8c;
  }
  .download-wrap {
    float: right;
    margin: -25px 0 18px;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #2b6ddf;

    img {
      margin-right: 8px;
    }
  }
  .radio-label {
    margin-bottom: 19px;
    display: flex;
    height: 32px;
    line-height: 32px;
    .name {
      margin-right: 24px;
    }
    .btn-label {
      display: block;
      width: 84px;
      height: 32px;
      margin-right: 10px;
      border-radius: 4px;
      border: 1px solid #d9d9d9;
      cursor: pointer;
      text-align: center;
      line-height: 32px;
    }
    .btn-label.isActive,
    .btn-label.default:hover {
      color: $--color-primary;
      background-color: #fffaed;
      border: 1px solid #ffc973;
    }
  }
  .data-table {
    margin-top: 16px;
    border: 1px solid #d9d9d9;
    overflow: hidden;
    border-radius: 3px;
    ::v-deep .el-table tr:last-child td {
      border-bottom: none;
    }
    ::v-deep .el-table::before {
      background: transparent;
    }
    ::v-deep .el-table th {
      background: #fafafa;
      line-height: 29px;
    }
    ::v-deep .el-table td {
      line-height: 29px;
      padding: 7px 0 6px;
    }
    img.icon-help {
      height: 10px;
      width: 10px;
    }
    .img-no {
      margin: 20px auto 10px auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .img-no-data-word {
        margin: 10px auto;
      }
    }
    ::v-deep .el-table__empty-text {
      line-height: 30px;
      margin-bottom: 15px;
      margin-top: 15px;
    }
    .all-look {
      color: #2b6ddf;
      // text-decoration: underline;

      display: flex;
      cursor: pointer;
      justify-content: center;
    }
  }
  .el-pagination {
    text-align: center;
    margin-top: 20px;
  }
}
.query-form {
  width: 60%;
  .el-form-item {
    margin-right: 95px;
  }

  .btn-query {
    width: 64px;
    height: 40px;
    background: #f5f5f5;
    border: 1px solid #d9d9d9;
    border-radius: 0px 4px 4px 0px;
    text-align: center;
    line-height: 40px;
    margin-left: -2px;
    cursor: pointer;
    &:hover {
      color: $--color-primary;
      background-color: #fffaed;
      border: 1px solid #ffc973;
    }
  }
}
::v-deep {
  .el-range-separator {
    padding: 0;
  }
  .el-form-item__label {
    color: #262626;
  }
}
::v-deep
  .el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
::v-deep
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  content: '';
}
</style>
